import { render, staticRenderFns } from "./commonEmpty.vue?vue&type=template&id=a8807eb0&scoped=true&"
import script from "./commonEmpty.vue?vue&type=script&lang=js&"
export * from "./commonEmpty.vue?vue&type=script&lang=js&"
import style0 from "./commonEmpty.vue?vue&type=style&index=0&id=a8807eb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8807eb0",
  null
  
)

export default component.exports